import { createActivityStore } from './activity-store.js';
import type { ActivityStore } from './activity-store.js';

export const activityStore: ActivityStore = createActivityStore();
